define('modules/editor/views/navigation_tabs',['require','exports','module','base/collectionview','../models/editorstate','lib/util','./navigation_tab','ldsh!../templates/navigation_tabs'],function(require, exports, module) {
  "use strict";

  var CollectionView = require("base/collectionview"),
    EditorState = require("../models/editorstate"),
    util = require("lib/util"),
    NavigationTab = require("./navigation_tab");

  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/navigation_tabs"),
    tagName: "div",
    itemContainer: ".navigation_tabs_container",
    className: "ed-tabs nav nav-tabs",
    itemView: NavigationTab,

    initialize: function () {
      this.isStepPopup = EditorState.isCurrentStepPopup();
    },

    helpers: function () {
      return {
        stepNumber: EditorState.getCurrentStepNumber()
      };
    },

    events: {
      "click .js-add-step": "addStep"
    },

    onRender: function() {
      this.$el.i18n();
      this.togglePopupBar();
      setTimeout(function(){
        util.adjustTabs();
      }, 500);
    },

    togglePopupBar: function() {
      this.$el.find('.popup-warning-advice').toggle(this.isStepPopup);
    },
  });
});

